/// <amd-module name="Widgets/TcmChartWidget/TcmChartWidget" />
import * as React from "react";

import { onClickFPS } from "VSS/Platform/FPS";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as VssLocation from "VSS/Platform/Location";
import * as VssUserClaims from "VSS/Platform/UserClaims";

import { ChartProviders } from "Tfs/Charting/ChartProviders";
import { ChartConfiguration } from "Tfs/Charting/Contracts/Reporting";
import * as TfsWidgetContext from "Tfs/Widget/Context";

import { CommonChartWidget } from "WidgetCommon/CommonChart/CommonChartWidget";

import { WidgetProps } from "Dashboards/WidgetContracts/WidgetProps";

export class TcmChartWidget extends VssComponent<WidgetProps> {
    constructor(props: WidgetProps, context: IVssComponentContext) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <CommonChartWidget
                hasClickPermission={this.canUserClickToTcmPage()}
                featureName={ChartProviders.testReports}
                className={"tcmchart-container"}
                handleNavigation={this.handleNavigation}
                getLinkUrl={this.getLinkUrl}
                linkDescription={"TestChartLink"}
                openLightBox={() => {}}
                {...this.props}
            />
        );
    }

    private canUserClickToTcmPage(): boolean {
        return VssUserClaims.userHasClaim(this.context.pageContext, VssUserClaims.UserClaims.Member);
    }

    // Allows Wit Chart to perform Fast Page switch on click.
    private handleNavigation = (url: string): void => {
        onClickFPS(this.context.pageContext, url, true);
    };

    /**
     * Get the URL to the Query Builder. This is used to generate the url for the graph click event.
     */
    private getLinkUrl = (chartConfiguration: ChartConfiguration): string => {
        const testPlanRouteId = "ms.vss-test-web.test-testplan-route";
        const queryResultsViewId = "_TestManagement";
        const projectId = TfsWidgetContext.getProject(this.context.pageContext).id;

        const featureFilter = chartConfiguration.transformOptions.filter;
        // Extract the planId from feature filter string. Not elegant, but this is consistent with how TCM extracts on server side TestReportsHelper.cs
        const planId = featureFilter.split("\u0026")[0].split("=")[1];
        const suiteId = chartConfiguration.groupKey;

        return VssLocation.routeUrl(this.context.pageContext, testPlanRouteId, {
            project: projectId,
            view: queryResultsViewId,
            planId: planId,
            suiteId: suiteId
        });
    };
}

VssComponent.register("tcmChartWidget", TcmChartWidget);
